const GTM_CONTAINER_ID = process.env.REACT_APP_GTM_ID;

const hasCookieConsentHelpers = () => (
  typeof window !== 'undefined'
  && !!window.CookieConsent
  && typeof window.CookieConsent.hasValidConsentBitmask === 'function'
  && typeof window.CookieConsent.isAnalyticsEnabled === 'function'
  && typeof window.CookieConsent.isMarketingEnabled === 'function'
);

const getGoogleConsentState = () => {
  if (typeof window === 'undefined' || !hasCookieConsentHelpers()) {
    return {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    };
  }

  const hasValidBitmask = window.CookieConsent.hasValidConsentBitmask();
  const analyticsGranted = hasValidBitmask && window.CookieConsent.isAnalyticsEnabled();
  const marketingGranted = hasValidBitmask && window.CookieConsent.isMarketingEnabled();

  return {
    analytics_storage: analyticsGranted ? 'granted' : 'denied',
    ad_storage: marketingGranted ? 'granted' : 'denied',
    ad_user_data: marketingGranted ? 'granted' : 'denied',
    ad_personalization: marketingGranted ? 'granted' : 'denied',
  };
};

const hasLiveGoogleTags = () => (
  typeof window !== 'undefined'
  && !!GTM_CONTAINER_ID
  && typeof window.gtag === 'function'
  && Array.isArray(window.dataLayer)
);

export const initGoogleTags = () => hasLiveGoogleTags();

export const updateGoogleConsent = () => {
  if (!hasLiveGoogleTags()) {
    return;
  }

  window.gtag('consent', 'update', getGoogleConsentState());
};

export const trackPageView = (pagePath) => {
  if (!hasLiveGoogleTags()) {
    return;
  }

  updateGoogleConsent();
  window.dataLayer.push({
    event: 'page_view',
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });
};

if (typeof window !== 'undefined') {
  window.GoogleAnalytics = {
    init: initGoogleTags,
    updateConsent: updateGoogleConsent,
    trackPageView,
  };
}
